import { booleanAttribute, Component, HostBinding, inject, input } from "@angular/core";
import { VdsButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { SidebarService } from "../sidebar/sidebar.service";

@Component({
    selector: "vo-application-content",
    templateUrl: "./content.component.html",
    imports: [VdsButtonComponent]
})
export class ApplicationContentComponent {
    private sidebarService = inject(SidebarService);

    /**
     * Whether the content is scrollable or not.
     */
    isScrollable = input(false, { transform: booleanAttribute });

    /**
     * Whether the sidebar toggle button should be shown or not.
     */
    showSidebarToggle = input(true, { transform: booleanAttribute });

    /**
     * The label for the sidebar toggle button.
     */
    toggleSidebarButtonLabel = input<string>("Open filterpanel");

    @HostBinding("class") get hostClasses() {
        let classes = "relative flex-2 bg-white transition-all print:overflow-auto";

        if (this.isScrollable()) {
            classes += " overflow-y-auto overflow-x-hidden";
        } else {
            classes += " overflow-hidden";
        }

        return classes;
    }

    showSidebar() {
        this.sidebarService.showSidebar();
    }
}
